module.exports = __webpack_public_path__ + "media/images/icon-bookmark-6a972995d18264fd5bcf425e8df00253.svg";